import { useMemo } from 'react'

const toISO = d => {
	const pad2 = v => String(v).padStart(2, '0')
	return `${d.getFullYear()}-${pad2(d.getMonth() + 1)}-${pad2(d.getDate())}`
}

const isISODate = v => typeof v === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(v)

const normalizeISOFromRow = row => {
	if (!row) return ''
	if (isISODate(row.dueDate)) return row.dueDate
	if (isISODate(row.due)) return row.due
	if (typeof row.dueDate === 'string' && row.dueDate.includes('T'))
		return row.dueDate.slice(0, 10)
	return ''
}

export const useHeaderContent = ({ rows = [], sessions = [] } = {}) => {
	const { todayISO, tomorrowISO } = useMemo(() => {
		const now = new Date()
		const today = toISO(now)
		const tomorrow = toISO(
			new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1),
		)
		return { todayISO: today, tomorrowISO: tomorrow }
	}, [])

	const priorityAssignmentsCount = useMemo(() => {
		const src = Array.isArray(rows) ? rows : []
		let c = 0
		for (const r of src) {
			const iso = normalizeISOFromRow(r)
			if (!iso) continue
			if (iso === todayISO || iso === tomorrowISO) c++
		}
		return c
	}, [rows, todayISO, tomorrowISO])

	const todaySessionsCount = useMemo(() => {
		const src = Array.isArray(sessions) ? sessions : []
		return src.filter(s => s?.scheduledDateISO === todayISO).length
	}, [sessions, todayISO])

	const showReviewButton = priorityAssignmentsCount > 0
	const showViewSessionsButton = todaySessionsCount > 0

	const assignmentsLabel = useMemo(() => {
		if (priorityAssignmentsCount === 1)
			return 'You have 1 priority assignment today'
		return `You have ${priorityAssignmentsCount} priority assignments today`
	}, [priorityAssignmentsCount])

	const sessionsLabel = useMemo(() => {
		if (todaySessionsCount === 1) return '1 session scheduled'
		return `${todaySessionsCount} sessions scheduled`
	}, [todaySessionsCount])

	return {
		priorityAssignmentsCount,
		todaySessionsCount,
		showReviewButton,
		showViewSessionsButton,
		assignmentsLabel,
		sessionsLabel,
	}
}
